export const BACKUP_STATUS_SHOW_RESET = 'BACKUP_STATUS_SHOW_RESET'
export const BACKUP_STATUS_SHOW_SET_ERROR = 'BACKUP_STATUS_SHOW_SET_ERROR'
export const BACKUP_STATUS_SHOW_SET_RETRIEVED = 'BACKUP_STATUS_SHOW_SET_RETRIEVED'
export const BACKUP_STATUS_SHOW_TOGGLE_LOADING = 'BACKUP_STATUS_SHOW_TOGGLE_LOADING'
